import {
  Component,
  OnDestroy,
} from "@angular/core";

import { CommonModule } from "@angular/common";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { MatMenuModule, MatMenuTrigger, MatMenu } from "@angular/material/menu";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from '@angular/material/button';


@Component({
  selector: "app-suggested-sales",
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    HoverMenuDirective,
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatButtonModule
],
  templateUrl: "./suggested-sales.component.html",
  styleUrl: './suggested-sales.component.scss',
  providers: [],
})
export class SuggestedSalesComponent implements OnDestroy{

  ngOnDestroy(): void {
  }
}